import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphicalViewPCRoutingModule } from './graphical-view-pc-routing.module';
import { GraphicalViewPCComponent } from './graphical-view-pc.component';

@NgModule({
  declarations: [GraphicalViewPCComponent],
  imports: [
    CommonModule,
    GraphicalViewPCRoutingModule
  ]
})
export class GraphicalViewPCModule { }